<template>
  <div class="p-prepare">
  </div>
</template>

<script>
import { userAgentType, getQueryString } from '@/utils/index';
import { getLastVisitClass } from '@/api/pt';

export default {
  name: 'StudentAnalysis',
  components: {
  },
  data() {
    return {
      grade_id: 0,
      class_id: 0,
      masterClassId: 0,
    };
  },
  mounted() {
    this.getLastVisitClass();
  },
  methods: {
    getLastVisitClass() {
      getLastVisitClass().then((res) => {
        this.grade_id = res.data.grade_id;
        this.class_id = res.data.class_id;
        this.masterClassId = res.data.school_master_class_id;
        const userAgent = userAgentType();
        console.log(userAgent);
        if (userAgent.isPc || userAgent.isTablet) {
          this.jumpLink(true);
        } else {
          this.jumpLink(true);
        }
      });
    },
    jumpLink(type) {
      if (type) {
        this.$router.push({
          path: '/pt/class-analysis/classHome',
          query: {
            classId: getQueryString('classId') || this.class_id,
            gradeId: getQueryString('gradeId') || this.grade_id,
            masterClassId: getQueryString('masterClassId') || this.masterClassId,
          },
        });
      } else {
        this.$router.push({
          path: '/pt/class-analysis/AnalysisNoPc',
          query: {
            classId: getQueryString('classId') || this.class_id,
            gradeId: getQueryString('gradeId') || this.grade_id,
            masterClassId: getQueryString('masterClassId') || this.masterClassId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
